import ToolbarButton from './ToolbarButton'

export { ToolbarButton as default }
